import { BadgeVariants } from '~backoffice/app/~shared/components/ui/badge/badge.component';
import {
  CustomInvoiceStatus,
  InvoiceStatus,
  InvoiceType
} from '~core/models/invoice.models';

export const getInvoiceStatusName = (
  value: InvoiceStatus | CustomInvoiceStatus | undefined | null
): string => {
  if (!value) {
    return '';
  }

  switch (value) {
    case InvoiceStatus.draft:
      return 'Brouillon';

    case InvoiceStatus.processing:
      return 'En attente';

    case InvoiceStatus.validated:
      return 'En attente';

    case InvoiceStatus.certified:
      return 'Certifié';

    case InvoiceStatus.received:
      return 'Reçu';

    case InvoiceStatus.cancelled:
      return 'Annulé';

    case CustomInvoiceStatus.proforma:
      return 'Proforma';

    default:
      return '';
  }
};

export const getInvoiceStatusColor = (
  status: InvoiceStatus | CustomInvoiceStatus
): BadgeVariants['variant'] => {
  switch (status) {
    case InvoiceStatus.draft:
      return 'info';

    case InvoiceStatus.processing:
      return 'successLight';

    case InvoiceStatus.validated:
      return 'successLight';

    case InvoiceStatus.certified:
      return 'success';

    case InvoiceStatus.received:
      return 'successOutline';

    case InvoiceStatus.cancelled:
      return 'destructiveOutline';

    case CustomInvoiceStatus.proforma:
      return 'info';

    default:
      return 'info';
  }
};

export const getInvoiceTypeName = (
  value: InvoiceType | undefined | null
): string => {
  if (!value) {
    return '';
  }

  switch (value) {
    case InvoiceType.salesInvoice:
      return 'Facture de vente';

    case InvoiceType.creditNote:
      return "Facture d'avoir";

    case InvoiceType.proformaInvoice:
      return 'Facture Proforma';

    case InvoiceType.bapa:
      return 'Bordereau APA';

    default:
      return value;
  }
};

export const getInvoiceTypeColor = (
  status: InvoiceType
): BadgeVariants['variant'] => {
  switch (status) {
    case InvoiceType.salesInvoice:
      return 'primaryFancyOutlined';

    case InvoiceType.creditNote:
      return 'dangerFancyOutlined';

    case InvoiceType.proformaInvoice:
      return 'successFancyOutlined';

    case InvoiceType.bapa:
      return 'infoFancyOutlined';

    default:
      return 'info';
  }
};
